export default class HeroVideoInline {
  constructor() {
    const $els = document.querySelectorAll('.js-hero-video-inline');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    $el.querySelector('.js-play-video').addEventListener('click', (e) => {
      e.preventDefault();

      $el.querySelector('.js-headshot').classList.add('md:hidden');
      $el.querySelector('.js-poster').classList.add('hidden');
      $el.querySelector('.js-video').classList.remove('hidden');

      $el.querySelector('.js-video').firstChild.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
    });
  }

  playVideo(e) {
    e.preventDefault();

  }
}
